// Single source of truth for infrastructure acronyms that must render ALL-CAPS
// in user-facing labels (deal types, counterpart roles, technologies).
//
// To add a new acronym, append ONE entry below — every label path that uses
// capAcronyms()/fmtLabel() (and the inline title-case formatters, which mirror
// this alternation) will pick it up.
export const ACRONYMS = ['PPA', 'IPO', 'EPC', 'IPP'];

const ACRONYM_RE = new RegExp(`\\b(${ACRONYMS.join('|')})\\b`, 'gi');

// Uppercase any acronym word inside an already-built label string, regardless
// of the casing it arrived in ("Ppa" / "ppa" / "Epc Contractors" -> "PPA" /
// "PPA" / "EPC Contractors"). Whole-word only — never touches substrings.
export const capAcronyms = (s) => (s == null ? s : String(s).replace(ACRONYM_RE, (m) => m.toUpperCase()));

// Full enum-value formatter: underscores -> spaces, Title Case each word, then
// force acronyms to caps. e.g. "supply_agreement" -> "Supply Agreement",
// "ppa" -> "PPA", "epc" -> "EPC".
export const fmtLabel = (v) =>
  v == null || v === ''
    ? ''
    : capAcronyms(String(v).replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()));
